import React, { FC } from 'react';
import { ComponentRendering, isEditorActive, Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import HeroSectionText from './components/heroSectionText';
import HeroSectionCarousel from '../@shared/heroSectionCarousel';
import { TContentHubProductModelDetailHeroSectionProps } from './types/productModelDetailHeroSection.types';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import { modelOverviewVisible } from '../../constants/analytics.constants';
import './styles.scss';

const ProductModelDetailHeroSection: FC<TContentHubProductModelDetailHeroSectionProps> = (props) => {
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <section className="product-hero-section">
        <div className="product-hero-section__placeholder">
          <div className="product-hero-section__placeholder__container">
            <Placeholder name="jss-breadcrumb" rendering={props.rendering as ComponentRendering} />
          </div>
        </div>
        <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
      </section>
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent event={modelOverviewVisible}>
      <section className="product-hero-section">
        <div className="product-hero-section__placeholder">
          <div className="product-hero-section__placeholder__container">
            <Placeholder name="jss-breadcrumb" rendering={props.rendering as ComponentRendering} />
          </div>
        </div>
        <div className="product-hero-section__container">
          <HeroSectionCarousel fields={props.fields} />
          <HeroSectionText fields={props.fields} params={props.params} rendering={props.rendering as ComponentRendering} />
        </div>
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(ProductModelDetailHeroSection);
